import httpClient from '../httpClient';

export async function getAllSesVinculo() {
  try {
    const response = await httpClient.get(`/api/vinculosesusuario`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de SESVINCULO: ' + error);
  }
}

export async function getSesVinculo(sesvinculoID: string) {
  try {
    const response = await httpClient.get(
      `/api/vinculosesusuario/${sesvinculoID}`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter SESVINCULO: ' + error);
  }
}

export async function getSesVinculoBySesId(sesId: string) {
  try {
    const response = await httpClient.get(
      `/api/vinculosesusuario/ses/${sesId}`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Usuários da SES: ' + error);
  }
}
